/* eslint-disable import/first */
import React from 'react';
import { Dialog, DialogTitle, Grid, Typography, DialogContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';
import BackButton from '../BackButton';
import css from './index.module.scss';
import ClassNames from 'classnames';
import { useLocation } from '@reach/router';
import { Redux, Slices } from 'spwa-ui-library';

const { useSelector, useDispatch } = Redux;

const { updateProductPayload } = Slices.tempCartSlice;

export default function DialogBox(props) {
  const location = useLocation();
  const dispatch = useDispatch();
  const tempCartItems = useSelector((state) => state?.tempCart?.data?.items);
  const tempCustItems = useSelector((state) => state?.tempCart?.customize?.items);
  const useStyles = makeStyles((theme) => ({
    dialogPaper: {
      maxWidth: props.maxWidth || '190rem',
      borderRadius: '2rem',
      backgroundColor: '#F1F3F6',
      maxHeight: '89vh',
      overflowX: props.overflowX,
      // overflowY: 'hidden',
    },
    root: {
      zIndex: '1310 !important',
    },
    MiDialogContent: {
      overflow: props.description === 'Customize Your Meal' || props.hidden ? 'hidden' : 'auto',
      root: {
        padding: 0,
      },
    },
  }));
  const vardialogPaper = useStyles();

  let isCustomizationDialog = props?.description?.includes('|');

  let customizationElements = null;
  if (isCustomizationDialog) {
    let [productName, productPrice] = props?.description?.split('|');
    customizationElements = (
      <>
        <Typography
          className={css.customizationProductName}
        >{`${productName?.trim()} | `}</Typography>
        <Typography
          className={css.customizationProductPrice}
        >{`${productPrice?.trim()}`}</Typography>
      </>
    );
  }

  const handleClose = () => {
    window.localStorage.setItem('notShowBogoPopup', true);
    const pathname = location.pathname;
    const params = pathname.split('/');
    const locationSearch = new URLSearchParams(location.search);

    if (locationSearch.has('main_product')) {
      const mainProduct = locationSearch.get('main_product');
      const productId = params[params.length - 1];
      const step = locationSearch.get('step');

      const productCustomization = JSON.parse(
        JSON.stringify(tempCartItems.find((item) => item.id == mainProduct))
      );

      let shouldUpdatePayload = !!productCustomization?.['bundle']?.[step]?.[productId]?.notAdded;

      const prevCustomization = tempCustItems.find((item) => item.id == mainProduct);

      if (productCustomization?.['bundle']?.[step]?.[productId]) {
        let customizationExists = !!productCustomization['bundle'][step][productId];
        delete productCustomization['bundle'][step][productId];
        if (customizationExists && prevCustomization?.['bundle']?.[step]?.[productId]) {
          productCustomization['bundle'][step][productId] =
            prevCustomization?.['bundle']?.[step]?.[productId] || {};
        }
      }
      if (productCustomization?.['subItem']?.[step]?.[productId]) {
        let customizationExists = !!productCustomization['subItem'][step][productId];
        delete productCustomization['subItem'][step][productId];
        if (customizationExists && prevCustomization?.['subItem']?.[step]?.[productId]) {
          productCustomization['subItem'][step][productId] =
            prevCustomization?.['subItem']?.[step]?.[productId] || {};
        }
      }
      if (productCustomization?.['items']?.[step]?.[productId]) {
        let customizationExists = !!productCustomization['items'][step][productId];
        delete productCustomization['items'][step][productId];
        if (customizationExists && prevCustomization?.['items']?.[step]?.[productId]) {
          productCustomization['items'][step][productId] =
            prevCustomization?.['items']?.[step]?.[productId] || {};
        }
      }

      let localProductBackup = window.localStorage.getItem('customizationData');
      let data = localProductBackup ? JSON.parse(localProductBackup) : productCustomization;

      if (localProductBackup) {
        dispatch(updateProductPayload({ data: data }));
        window.localStorage.removeItem('customizationData');
      }
      window.localStorage.setItem('backButtonPressed', 1);
    }

    props?.onClose && props.onClose();
  };

  return (
    <Dialog
      open={props.isOpen}
      onClose={handleClose}
      classes={{ paper: vardialogPaper.dialogPaper, root: vardialogPaper.root }}
    >
      <DialogContent
        className={`${vardialogPaper.MiDialogContent} ${css.rootBackground} ${props.className}`}
      >
        {!props.hideCloseButton && (
          <Grid className={css.closeButton}>
            <Grid onClick={handleClose}>
              {/* <GrClose size=".8em" /> */}
              &times;
            </Grid>
          </Grid>
        )}
        {(props.title || props.titleId || props.description) && (
          <DialogTitle
            id={'titleDig'}
            className={props.page === 'login' ? css.loginDialogTitle : css.dialogTitle}
          >
            <Grid
              className={ClassNames(css.DialogHeaderGrid, {
                [css.leftAlign]: props.leftAlign,
                [props.titleClass]: props?.titleClass,
              })}
            >
              <Typography>
                {props.titleId ? (
                  <>
                    <FormattedMessage id={props.titleId} />
                  </>
                ) : isCustomizationDialog ? (
                  customizationElements
                ) : (
                  <>{props.title || props.description}</>
                )}
              </Typography>
              <div className={css.backButtonContainer}>
                <BackButton handleBack={handleClose} type="cross" />
              </div>
            </Grid>
            <Grid className={css.DialogTitleDesc}>
              <Typography>{props.titleDesc}</Typography>
            </Grid>
          </DialogTitle>
        )}
        {props.children}
      </DialogContent>
    </Dialog>
  );
}
